// import React, { useState, useEffect } from "react";
// import { TextField, MenuItem, Grid, Typography, CircularProgress, Button, Collapse, Chip, ListItemText, Checkbox, Box } from "@mui/material";
// import { FilterList as FilterListIcon } from "@mui/icons-material";
// import axios from "axios";
// import PrePostLaminationTable from "./FormTables/PrePostLaminationTable";
// import BOMTable from "./FormTables/BOMTable";
// import DailyVolumeTable from "./FormTables/DailyVolumeTable";
// import StringerTable from "./FormTables/StringerTable";
// import CellToRibbonPeelStrengthTable from "./FormTables/CellToRibbonPeelStrengthTable";
// import PeelStrengthTable from "./FormTables/PeelStrengthTable";
// import LaminationMachineTable from "./FormTables/LaminationMachineTable";
// import CalibrationVerificationTable from "./FormTables/CalibrationVerificationTable";
// import FlashTestWitnessTable from "./FormTables/FlashTestWitnessTable";
// import PrimaryModuleCalibrationTable from "./FormTables/PrimaryModuleCalibrationTable";
// import FrameSealantWeightTable from "./FormTables/FrameSealantWeightTable";
// import JunctionBoxSealantWeightTable from "./FormTables/JunctionBoxSealantWeightTable";
// import JunctionBoxPottingMaterialTable from "./FormTables/JunctionBoxPottingMaterialTable";
// import ModuleDimensionCheckTable from "./FormTables/ModuleDimensionCheckTable";
// import RecordRejectedModuleTable from "./FormTables/RecordRejectedModuleTable";
// import RFIDReadabilityTable from "./FormTables/RFIDReadabilityTable";
// import MachineBreakdownHistoryTable from "./FormTables/MachineBreakdownHistoryTable";
// import RootCauseAnalysisTable from "./FormTables/RootCauseAnalysisTable";

// const formMappings = {
//   "Pre-Lamination": "PreLamination",
//   "Post-Lamination": "PostLamination",
//   "Bill of material verification": "BOM",
//   "Daily volume of the qualified modules": "dailyVolumeQualifiedModules",
//   "Stringer": "stringer",
//   "Peel Strength Of Ribbon To String Connector": "PeelStrength",
//   "Cell To Ribbon Peel Strength": "CellToRibbonPeelStrength",
//   "Lamination machine parameters verification": "LaminationMachine",
//   "Calibration data verification of secondary module": "calibrationVerificationOfSecondaryModule",
//   "Flash test witness record after calibration": "FlashTestWitnessRecordAfterCalibration",
//   "Primary (Golden) Module Calibration record": "PrimaryModuleCalibrationRecord",
//   "Frame sealant weight verification": "FrameSealantWeightVerification",
//   "Junction Box sealant weight verification": "JunctionBoxSealantWeightVerification",
//   "Junction Box Potting material ratio verification": "JunctionBoxPottingMaterial",
//   "Module dimensions check": "ModuleDimensionCheck",
//   "Record of rejected module during inspection": "RecordRejectedModuleDuringInspection",
//   "RFID Readability and Data Verification": "RFIDReadability",
//   "Machine Breakdown History": "MachineBreakdownHistory",
//   "Root Cause Analysis": "RootCauseAnalysis",
// };

// // Sub-form mappings for Pre-Lamination
// const preLaminationSubFormMappings = {
//   "Shop Floor (Pre)": "shopFloor_pre",
//   "Cell and Cutting Machine (Pre)": "CellAndCuttingMachine_pre",
//   "Encapsulation Material (Front) (Pre)": "encapsulationMaterialFront_pre",
//   "Encapsulation Material (Back) (Pre)": "encapsulationMaterialBack_pre",
//   "Glass (Front & Back) (Pre)": "GlassFrontBack_pre",
//   "Tabbing & Stringing (Pre)": "TabbingStringing_pre",
//   "Auto Bussing (Pre)": "autoBussing_pre",
//   "Barcode/RFID (Pre)": "barCodeRFID_pre",
//   "Pre-Lamination EL & Re-work (Pre)": "PreLaminationELRework_pre",
// };

// // Sub-form mappings for Post-Lamination
// const postLaminationSubFormMappings = {
//   "Lamination (Post)": "Lamination_post",
//   "Trimming/VI at 90 Degree (Post)": "Trimming_post",
//   "Framing (Post)": "Framing_post",
//   "JB Assembling & Soldering (Post)": "JbAssemblingSoldering_post",
//   "Curing (Post)": "Curing_post",
//   "Cleaning (Post)": "Cleaning_post",
//   "Electrical Test (Post)": "electricalTest_post",
//   "HiPot (Post)": "HiPot_post",
//   "Post-Lamination EL (Post)": "PostLaminationEL_post",
//   "Visual Inspection (Post)": "VisualInspections_post",
//   "Packing (Post)": "Packing_post",
// };

// // Sub-form mappings for BOM
// const bomSubFormMappings = {

//   "Adhesive Sealant (BOM)": "AdhesiveSealant",
//   "Cell (BOM)": "Cell",
//   "Frame (BOM)": "Frame",
//   "Cell Fixing Type (BOM)": "cellFixingType",
//   "EVA Back (BOM)": "evaBack",
//   "EVA Front (BOM)": "evaFront",
//   "Flux (BOM)": "flux",
//   "Glass Back (BOM)": "glassBack",
//   "Glass Front (BOM)": "glassFront",
//   "Interconnector (BOM)": "interconnector",
//   "Junction Box (BOM)": "junctionBox",
//   "Potting Material (BOM)": "pottingMaterial",
//   "String Connector (BOM)": "stringConnector",
// };


// const InspectionSummary = () => {
//   const [supplier, setSupplier] = useState("");
//   const [shift, setShift] = useState([]);
//   const [startDate, setStartDate] = useState("");
//   const [endDate, setEndDate] = useState("");
//   const [formName, setFormName] = useState([]);
//   const [subForm, setSubForm] = useState([]);
//   const [tableData, setTableData] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [suppliers, setSuppliers] = useState([]);
//   const [supplierShifts, setSupplierShifts] = useState([]);
//   const [showFilters, setShowFilters] = useState(false);
//   const baseURL = process.env.REACT_APP_API_BASE_URL;

//   // Form names for UI display
//   const formNames = Object.keys(formMappings);

//   // Fetch suppliers when the component mounts
//   useEffect(() => {
//     const fetchSuppliers = async () => {
//       try {
//         const selectedProject = localStorage.getItem("selectedProject");
//         if (!selectedProject) {
//           setError("Project ID not found in local storage");
//           return;
//         }

//         const response = await apiClient.post(`get_supplier_names`, {
//           projectId: selectedProject,
//         });

//         if (!Array.isArray(response.data)) {
//           setError("Invalid response format from supplier API");
//           return;
//         }

//         const supplierData = response.data
//           .map((info) => {
//             if (!info.name) {
//               console.warn("Skipping invalid supplier entry:", info);
//               return null;
//             }
//             return {
//               name: info.name,
//               shift: info.shift,
//             };
//           })
//           .filter(Boolean);

//         if (supplierData.length === 0) {
//           setError("No valid suppliers found");
//         }

//         setSuppliers(supplierData);
//       } catch (error) {
//         setError("Error collecting supplier information");
//         console.error("Supplier fetch error:", error);
//       }
//     };
//     fetchSuppliers();
//   }, []);

//   // Handle supplier change
//   const handleSupplierChange = (e) => {
//     const selectedSupplierName = e.target.value;
//     setSupplier(selectedSupplierName);
//     setShift([]);

//     const selectedSupplierData = suppliers.find((sup) => sup.name === selectedSupplierName);
//     if (selectedSupplierData) {
//       const shiftOptions =
//         selectedSupplierData.shift === "MorningAfternoonNight"
//           ? ["Morning", "Afternoon", "Night"]
//           : ["Day", "Night"];
//       setSupplierShifts(shiftOptions);
//     } else {
//       setSupplierShifts([]);
//     }
//   };

//   // Fetch inspection summary data
//   useEffect(() => {
//     const fetchData = async () => {
//       const projectId = localStorage.getItem("selectedProject");
//       if (
//         !projectId ||
//         !supplier ||
//         shift.length === 0 ||
//         !startDate ||
//         !endDate ||
//         formName.length === 0 ||
//         (formName.some((form) =>
//           ["Pre-Lamination", "Post-Lamination", "Bill of material verification"].includes(form)
//         ) && subForm.length === 0)
//       ) {
//         setTableData({});
//         return;
//       }

//       setLoading(true);
//       setError(null);

//       try {
//         const apiFormNames = formName.map((name) => formMappings[name]);
//         const apiSubForms = subForm.map((name) =>
//           preLaminationSubFormMappings[name] ||
//           postLaminationSubFormMappings[name] ||
//           bomSubFormMappings[name]
//         ).filter(Boolean);
        
//         const response = await axios.get(
//           `${baseURL}inspection_summary`,
//           {
//             params: {
//               projectId,
//               inspectionSupplier: supplier,
//               inspectionShift: shift.join(","),
//               date: startDate,
//               endDate,
//               formName: apiFormNames.join(","),
//               subForm: apiSubForms.join(","),
//             },
//           }
//         );

//         if (response.data.status === "success") {
//           const groupedData = formName.reduce((acc, uiFormName) => {
//             const apiFormName = formMappings[uiFormName];
//             acc[uiFormName] = [];

//             const dataArray = Array.isArray(response.data.data)
//               ? response.data.data
//               : [];
//             dataArray.forEach((item, index) => {

//               // Handle Pre/Post Lamination forms
//               if (item[apiFormName]) {
//                 const subFormData = item[apiFormName];
//                 Object.entries(subFormData).forEach(([apiSubForm, subFormDetails]) => {
//                   if (apiSubForms.length === 0 || apiSubForms.includes(apiSubForm)) {
//                     // Handle Tabbing & Stringing specifically
//                     if (apiSubForm === "TabbingStringing_pre" && subFormDetails.TabbingStringing) {
//                       Object.entries(subFormDetails.TabbingStringing).forEach(([tableName, observations]) => {
//                         if (Array.isArray(observations)) {
//                           observations.forEach((obs) => {
//                             acc[uiFormName].push({
//                               inspectionDate: item.inspectionDate ?? "N/A",
//                               inspectionShift: item.inspectionShift ?? "N/A",
//                               inspectionSupplier: item.inspectionSupplier ?? "N/A",
//                               inspectorName: item.inspectorName ?? "N/A",
//                               projectId,
//                               status: item.status ?? "N/A",
//                               subForm: apiSubForm,
//                               tableName,
//                               field: obs.product ?? obs.field ?? "N/A",
//                               frequency: obs.frequency ?? "N/A",
//                               specification: obs.specifications ?? obs.specification ?? "N/A",
//                               obs1: obs.observation1 ?? obs.obs1 ?? "N/A",
//                               obs2: obs.observation2 ?? obs.obs2 ?? "N/A",
//                               remarks: subFormDetails.nonConformance ?? "N/A",
//                             });
//                           });
//                         }
//                       });
//                     } else if (apiSubForm === "VisualInspections_post" && subFormDetails) {
//                       // Handle VisualInspections_post
//                       Object.entries(subFormDetails).forEach(([tableName, observations]) => {
//                         if (tableName === "nonConformance") return;
//                         if (Array.isArray(observations) && tableName !== "ModuleInspection") {
//                           observations.forEach((obs) => {
//                             acc[uiFormName].push({
//                               inspectionDate: item.inspectionDate ?? "N/A",
//                               inspectionShift: item.inspectionShift ?? "N/A",
//                               inspectionSupplier: item.inspectionSupplier ?? "N/A",
//                               inspectorName: item.inspectorName ?? "N/A",
//                               projectId,
//                               status: item.status ?? "N/A",
//                               subForm: apiSubForm,
//                               tableName,
//                               field: obs.product ?? obs.field ?? "N/A",
//                               frequency: obs.frequency ?? "N/A",
//                               specification: obs.specifications ?? obs.specification ?? "N/A",
//                               obs1: obs.observation1 ?? obs.obs1 ?? "N/A",
//                               obs2: obs.observation2 ?? obs.obs2 ?? "N/A",
//                               remarks: subFormDetails.nonConformance ?? "N/A",
//                             });
//                           });
//                         }
//                         // Case: ModuleInspection table
//                         if (tableName === "ModuleInspection" && Array.isArray(observations)) {
//                           observations.forEach((module) => {
//                             acc[uiFormName].push({
//                               inspectionDate: item.inspectionDate ?? "N/A",
//                               inspectionShift: item.inspectionShift ?? "N/A",
//                               inspectionSupplier: item.inspectionSupplier ?? "N/A",
//                               inspectorName: item.inspectorName ?? "N/A",
//                               projectId,
//                               status: item.status ?? "N/A",
//                               subForm: apiSubForm,
//                               tableName,
//                               moduleInspection: module.moduleNumber ?? "N/A",
//                               moduleStatus: module.status ?? "N/A",
//                               remarks: module.remarks ?? "", // Use module.remarks directly
//                             });
//                           });
//                         }
//                       });
//                     } else {
//                       // Handle other subforms
//                       Object.entries(subFormDetails).forEach(([tableName, value]) => {
//                         if (tableName === "nonConformance" || tableName === "ModuleInspection") return; // Skip ModuleInspection
//                         if (Array.isArray(value)) {
//                           value.forEach((obs) => {
//                             acc[uiFormName].push({
//                               inspectionDate: item.inspectionDate ?? "N/A",
//                               inspectionShift: item.inspectionShift ?? "N/A",
//                               inspectionSupplier: item.inspectionSupplier ?? "N/A",
//                               inspectorName: item.inspectorName ?? "N/A",
//                               projectId,
//                               status: item.status ?? "N/A",
//                               subForm: apiSubForm,
//                               tableName,
//                               field: obs.field ?? obs.product ?? "N/A",
//                               frequency: obs.frequency ?? "N/A",
//                               specification: obs.specifications ?? obs.specification ?? "N/A",
//                               obs1: obs.observation1 ?? obs.obs1 ?? "N/A",
//                               obs2: obs.observation2 ?? obs.obs2 ?? "N/A",
//                               remarks: subFormDetails.nonConformance ?? "N/A",
//                               moduleInspection: obs.moduleNumber ?? "N/A",
//                             });
//                           });
//                         }
//                       });
//                     }
//                   }
//                 });
//               }              
//               // Handle Bill of material verification
//               else if (
//                 uiFormName === "Bill of material verification" &&
//                 item.form_name === "BOM"
//               ) {
//                 if (
//                   apiSubForms.length === 0 ||
//                   !item.sub_form ||
//                   apiSubForms.includes(item.sub_form)
//                 ) 
//                 {
//                   acc[uiFormName].push({
//                     inspectionDate: item.inspectionDate ?? "N/A",
//                     inspectionShift: item.inspectionShift ?? "N/A",
//                     inspectionSupplier: item.inspectionSupplier ?? "N/A",
//                     inspectorName: item.inspectorName ?? "N/A",
//                     projectId: item.projectId ?? "N/A",
//                     status: item.status ?? "N/A",
//                     zip_url: item.zip_url || "N/A",
//                     form_data: item.form_data || {},
//                   });
//                 }
                
//               }
//               // Handle Daily volume of the qualified modules
//               else if (
//                 uiFormName === "Daily volume of the qualified modules" &&
//                 item.form_name === "dailyVolumeQualifiedModules"
//               ) {
//                 if (
//                   apiSubForms.length === 0 ||
//                   !item.sub_form ||
//                   apiSubForms.includes(item.sub_form)
//                 ) {
//                   acc[uiFormName].push({
//                     inspectionDate: item.inspectionDate ?? "N/A",
//                     inspectionShift: item.inspectionShift ?? "N/A",
//                     inspectionSupplier: item.inspectionSupplier ?? "N/A",
//                     inspectorName: item.inspectorName ?? "N/A",
//                     projectId: item.projectId ?? "N/A",
//                     status: item.status ?? "N/A",
//                     form_data: item.form_data || {},
//                   });
//                 }
//               }
//               // Handle Stringer
//               else if (
//                 uiFormName === "Stringer" &&
//                 item.form_name === "stringer"
//               ) {
//                 if (
//                   apiSubForms.length === 0 ||
//                   !item.sub_form ||
//                   apiSubForms.includes(item.sub_form)
//                 ) {
//                   acc[uiFormName].push({
//                     inspectionDate: item.inspectionDate ?? "N/A",
//                     inspectionShift: item.inspectionShift ?? "N/A",
//                     inspectionSupplier: item.inspectionSupplier ?? "N/A",
//                     inspectorName: item.inspectorName ?? "N/A",
//                     projectId: item.projectId ?? "N/A",
//                     status: item.status ?? "N/A",
//                     form_data: item.form_data || {},
//                   });
//                 }
//               }
//               // Handle Cell To Ribbon Peel Strength
//               else if (
//                 uiFormName === "Cell To Ribbon Peel Strength" &&
//                 item.form_name === "CellToRibbonPeelStrength"
//               ) {
//                 if (
//                   apiSubForms.length === 0 ||
//                   !item.sub_form ||
//                   apiSubForms.includes(item.sub_form)
//                 ) {
//                   acc[uiFormName].push({
//                     inspectionDate: item.inspectionDate ?? "N/A",
//                     inspectionShift: item.inspectionShift ?? "N/A",
//                     inspectionSupplier: item.inspectionSupplier ?? "N/A",
//                     inspectorName: item.inspectorName ?? "N/A",
//                     projectId: item.projectId ?? "N/A",
//                     status: item.status ?? "N/A",
//                     form_data: item.form_data || {},
//                     zip_url: item.zip_url || "N/A",
//                   });
//                 }
//               }
//               // Handle Peel Strength Of Ribbon To String Connector
//               else if (
//                 uiFormName === "Peel Strength Of Ribbon To String Connector" &&
//                 item.form_name === "PeelStrength"
//               ) {
//                 if (
//                   apiSubForms.length === 0 ||
//                   !item.sub_form ||
//                   apiSubForms.includes(item.sub_form)
//                 ) {
//                   acc[uiFormName].push({
//                     inspectionDate: item.inspectionDate ?? "N/A",
//                     inspectionShift: item.inspectionShift ?? "N/A",
//                     inspectionSupplier: item.inspectionSupplier ?? "N/A",
//                     inspectorName: item.inspectorName ?? "N/A",
//                     projectId: item.projectId ?? "N/A",
//                     status: item.status ?? "N/A",
//                     form_data: item.form_data || {},
//                     zip_url: item.zip_url || "N/A",
//                   });
//                 }
//               }
//               // Handle Lamination machine parameters verification
//               else if (
//                 uiFormName === "Lamination machine parameters verification" &&
//                 item.form_name === "LaminationMachine"
//               ) {
//                 if (
//                   apiSubForms.length === 0 ||
//                   !item.sub_form ||
//                   apiSubForms.includes(item.sub_form)
//                 ) {
//                   acc[uiFormName].push({
//                     inspectionDate: item.inspectionDate ?? "N/A",
//                     inspectionShift: item.inspectionShift ?? "N/A",
//                     inspectionSupplier: item.inspectionSupplier ?? "N/A",
//                     inspectorName: item.inspectorName ?? "N/A",
//                     projectId: item.projectId ?? "N/A",
//                     status: item.status ?? "N/A",
//                     form_data: item.form_data || {},
//                   });
//                 }
//               }
//               // Handle Calibration data verification of secondary module
//               else if (
//                 uiFormName === "Calibration data verification of secondary module" &&
//                 item.form_name === "calibrationVerificationOfSecondaryModule"
//               ) {
//                 if (
//                   apiSubForms.length === 0 ||
//                   !item.sub_form ||
//                   apiSubForms.includes(item.sub_form)
//                 ) {
//                   acc[uiFormName].push({
//                     inspectionDate: item.inspectionDate ?? "N/A",
//                     inspectionShift: item.inspectionShift ?? "N/A",
//                     inspectionSupplier: item.inspectionSupplier ?? "N/A",
//                     inspectorName: item.inspectorName ?? "N/A",
//                     projectId: item.projectId ?? "N/A",
//                     status: item.status ?? "N/A",
//                     form_data: item.form_data || {},
//                   });
//                 }
//               }
//               // Handle Flash test witness record after calibration
//               else if (
//                 uiFormName === "Flash test witness record after calibration" &&
//                 item.form_name === "FlashTestWitnessRecordAfterCalibration"
//               ) {
//                 if (
//                   apiSubForms.length === 0 ||
//                   !item.sub_form ||
//                   apiSubForms.includes(item.sub_form)
//                 ) {
//                   acc[uiFormName].push({
//                     inspectionDate: item.inspectionDate ?? "N/A",
//                     inspectionShift: item.inspectionShift ?? "N/A",
//                     inspectionSupplier: item.inspectionSupplier ?? "N/A",
//                     inspectorName: item.inspectorName ?? "N/A",
//                     projectId: item.projectId ?? "N/A",
//                     status: item.status ?? "N/A",
//                     form_data: item.form_data || {},
//                   });
//                 }
//               }
//               // Handle Primary (Golden) Module Calibration record
//               else if (
//                 uiFormName === "Primary (Golden) Module Calibration record" &&
//                 item.form_name === "PrimaryModuleCalibrationRecord"
//               ) {
//                 if (
//                   apiSubForms.length === 0 ||
//                   !item.sub_form ||
//                   apiSubForms.includes(item.sub_form)
//                 ) {
//                   acc[uiFormName].push({
//                     inspectionDate: item.inspectionDate ?? "N/A",
//                     inspectionShift: item.inspectionShift ?? "N/A",
//                     inspectionSupplier: item.inspectionSupplier ?? "N/A",
//                     inspectorName: item.inspectorName ?? "N/A",
//                     projectId: item.projectId ?? "N/A",
//                     status: item.status ?? "N/A",
//                     form_data: item.form_data || {},
//                   });
//                 }
//               }
//               // Handle Frame sealant weight verification
//               else if (
//                 uiFormName === "Frame sealant weight verification" &&
//                 item.form_name === "FrameSealantWeightVerification"
//               ) {
//                 if (
//                   apiSubForms.length === 0 ||
//                   !item.sub_form ||
//                   apiSubForms.includes(item.sub_form)
//                 ) {
//                   acc[uiFormName].push({
//                     inspectionDate: item.inspectionDate ?? "N/A",
//                     inspectionShift: item.inspectionShift ?? "N/A",
//                     inspectionSupplier: item.inspectionSupplier ?? "N/A",
//                     inspectorName: item.inspectorName ?? "N/A",
//                     projectId: item.projectId ?? "N/A",
//                     status: item.status ?? "N/A",
//                     form_data: item.form_data || {},
//                   });
//                 }
//               }
//               // Handle Junction Box sealant weight verification
//               else if (
//                 uiFormName === "Junction Box sealant weight verification" &&
//                 item.form_name === "JunctionBoxSealantWeightVerification"
//               ) {
//                 if (
//                   apiSubForms.length === 0 ||
//                   !item.sub_form ||
//                   apiSubForms.includes(item.sub_form)
//                 ) {
//                   acc[uiFormName].push({
//                     inspectionDate: item.inspectionDate ?? "N/A",
//                     inspectionShift: item.inspectionShift ?? "N/A",
//                     inspectionSupplier: item.inspectionSupplier ?? "N/A",
//                     inspectorName: item.inspectorName ?? "N/A",
//                     projectId: item.projectId ?? "N/A",
//                     status: item.status ?? "N/A",
//                     form_data: item.form_data || {},
//                   });
//                 }
//               }
//               // Handle Junction Box Potting material ratio verification
//               else if (
//                 uiFormName === "Junction Box Potting material ratio verification" &&
//                 item.form_name === "JunctionBoxPottingMaterial"
//               ) {
//                 if (
//                   apiSubForms.length === 0 ||
//                   !item.sub_form ||
//                   apiSubForms.includes(item.sub_form)
//                 ) {
//                   acc[uiFormName].push({
//                     inspectionDate: item.inspectionDate ?? "N/A",
//                     inspectionShift: item.inspectionShift ?? "N/A",
//                     inspectionSupplier: item.inspectionSupplier ?? "N/A",
//                     inspectorName: item.inspectorName ?? "N/A",
//                     projectId: item.projectId ?? "N/A",
//                     status: item.status ?? "N/A",
//                     form_data: item.form_data || {},
//                   });
//                 }
//               }
//               // Handle Module dimensions check
//               else if (
//                 uiFormName === "Module dimensions check" &&
//                 item.form_name === "ModuleDimensionCheck"
//               ) {
//                 if (
//                   apiSubForms.length === 0 ||
//                   !item.sub_form ||
//                   apiSubForms.includes(item.sub_form)
//                 ) {
//                   acc[uiFormName].push({
//                     inspectionDate: item.inspectionDate ?? "N/A",
//                     inspectionShift: item.inspectionShift ?? "N/A",
//                     inspectionSupplier: item.inspectionSupplier ?? "N/A",
//                     inspectorName: item.inspectorName ?? "N/A",
//                     projectId: item.projectId ?? "N/A",
//                     status: item.status ?? "N/A",
//                     form_data: item.form_data || {},
//                   });
//                 }
//               }
//               // Handle Record of rejected module during inspection
//               else if (
//                 uiFormName === "Record of rejected module during inspection" &&
//                 item.form_name === "RecordRejectedModuleDuringInspection"
//               ) {
//                 if (
//                   apiSubForms.length === 0 ||
//                   !item.sub_form ||
//                   apiSubForms.includes(item.sub_form)
//                 ) {
//                   acc[uiFormName].push({
//                     inspectionDate: item.inspectionDate ?? "N/A",
//                     inspectionShift: item.inspectionShift ?? "N/A",
//                     inspectionSupplier: item.inspectionSupplier ?? "N/A",
//                     inspectorName: item.inspectorName ?? "N/A",
//                     projectId: item.projectId ?? "N/A",
//                     status: item.status ?? "N/A",
//                     form_data: item.form_data || {},
//                   });
//                 }
//               }
//               // Handle RFID Readability and Data Verification
//               else if (
//                 uiFormName === "RFID Readability and Data Verification" &&
//                 item.form_name === "RFIDReadability"
//               ) {
//                 if (
//                   apiSubForms.length === 0 ||
//                   !item.sub_form ||
//                   apiSubForms.includes(item.sub_form)
//                 ) {
//                   acc[uiFormName].push({
//                     inspectionDate: item.inspectionDate ?? "N/A",
//                     inspectionShift: item.inspectionShift ?? "N/A",
//                     inspectionSupplier: item.inspectionSupplier ?? "N/A",
//                     inspectorName: item.inspectorName ?? "N/A",
//                     projectId: item.projectId ?? "N/A",
//                     status: item.status ?? "N/A",
//                     form_data: item.form_data || {},
//                     zip_url: item.zip_url || "N/A",
//                   });
//                 }
//               }
//               // Handle Machine Breakdown History
//               else if (
//                 uiFormName === "Machine Breakdown History" &&
//                 item.form_name === "MachineBreakdownHistory"
//               ) {
//                 if (
//                   apiSubForms.length === 0 ||
//                   !item.sub_form ||
//                   apiSubForms.includes(item.sub_form)
//                 ) {
//                   acc[uiFormName].push({
//                     inspectionDate: item.inspectionDate ?? "N/A",
//                     inspectionShift: item.inspectionShift ?? "N/A",
//                     inspectionSupplier: item.inspectionSupplier ?? "N/A",
//                     inspectorName: item.inspectorName ?? "N/A",
//                     projectId: item.projectId ?? "N/A",
//                     status: item.status ?? "N/A",
//                     form_data: item.form_data || {},
//                   });
//                 }
//               }
//               // Handle Root Cause Analysis
//               else if (
//                 uiFormName === "Root Cause Analysis" &&
//                 item.form_name === "RootCauseAnalysis"
//               ) {
//                 if (
//                   apiSubForms.length === 0 ||
//                   !item.sub_form ||
//                   apiSubForms.includes(item.sub_form)
//                 ) {
//                   acc[uiFormName].push({
//                     inspectionDate: item.inspectionDate ?? "N/A",
//                     inspectionShift: item.inspectionShift ?? "N/A",
//                     inspectionSupplier: item.inspectionSupplier ?? "N/A",
//                     inspectorName: item.inspectorName ?? "N/A",
//                     projectId: item.projectId ?? "N/A",
//                     status: item.status ?? "N/A",
//                     form_data: item.form_data || {},
//                     zip_url: item.zip_url || "N/A",
//                   });
//                 }
//               }
//             });
//             return acc;
//           }, {});
//           setTableData(groupedData);
//         } else {
//           setError(response.data.message || "Failed to fetch data");
//           setTableData({});
//         }
//       } catch (err) {
//         setError("Failed to fetch data");
//         console.error("Fetch error:", err);
//         setTableData({});
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, [supplier, shift, startDate, endDate, formName, subForm]);

//   // Toggle filter visibility
//   const toggleFilters = () => {
//     setShowFilters((prev) => !prev);
//   };

//   // Determine available subforms
//   const availableSubForms = (() => {
//     let subforms = [];
//     if (formName.includes("Pre-Lamination")) {
//       subforms = [...subforms, ...Object.keys(preLaminationSubFormMappings)];
//     }
//     if (formName.includes("Post-Lamination")) {
//       subforms = [...subforms, ...Object.keys(postLaminationSubFormMappings)];
//     }
//     if (formName.includes("Bill of material verification")) {
//       subforms = [...subforms, ...Object.keys(bomSubFormMappings)];
//     }
//     return [...new Set(subforms)];
//   })();

//   const handleFormNameChange = (e) => {
//     let selectedForms = e.target.value;   

//     const lastClicked = selectedForms[selectedForms.length - 1];

//     if (lastClicked === "all") {
      
//       if (formName.length === formNames.length) {
//         selectedForms = [];               
//       } else {
//         selectedForms = [...formNames];   
//       }
//     }

//     selectedForms = selectedForms.filter(item => item !== "all");

//     setFormName(selectedForms);

//     const requiredForms = [
//       "Pre-Lamination",
//       "Post-Lamination",
//       "Bill of material verification"
//     ];

//     const hasAnyRequired = requiredForms.some(form => selectedForms.includes(form));

//     if (!hasAnyRequired) {
//       setSubForm([]);                              
//     } else {
      
//       const newSubForms = subForm.filter(sub => availableSubForms.includes(sub));
//       setSubForm(newSubForms);
//     }
//   };

//   const handleSubFormChange = (e) => {
//     let value = e.target.value;
//     if (value[value.length - 1] === "all") {
//       setSubForm(subForm.length === availableSubForms.length ? [] : [...availableSubForms]);
//       return;
//     }
//     setSubForm(value.filter(v => v !== "all"));
//   };

//   return (
//     <div style={{ padding: "20px" }}>
//       <Typography variant="h5" gutterBottom>
//         Inspection Summary
//       </Typography>

//       <Button
//         variant="outlined"
//         startIcon={<FilterListIcon />}
//         onClick={toggleFilters}
//         style={{ marginBottom: "20px" }}
//       >
//         {showFilters ? "Hide Filters" : "Show Filters"}
//       </Button>

//       <Collapse in={showFilters}>
//         <Grid container spacing={2} style={{ marginBottom: "20px" }}>
//           <Grid item xs={12} sm={4} md={2}>
//             <TextField
//               select
//               label="Supplier"
//               value={supplier}
//               onChange={handleSupplierChange}
//               fullWidth
//               size="small"
//             >
//               {suppliers.map((option) => (
//                 <MenuItem key={option.name} value={option.name}>
//                   {option.name}
//                 </MenuItem>
//               ))}
//             </TextField>
//           </Grid>
//           <Grid item xs={12} sm={4} md={2}>
//             <TextField
//               select
//               label="Shift"
//               value={shift}
//               onChange={(e) => setShift(e.target.value)}
//               fullWidth
//               size="small"
//               disabled={!supplier}
//               SelectProps={{
//                 multiple: true,
//                 renderValue: (selected) => (
//                   <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
//                     {selected.map((value) => (
//                       <Chip key={value} label={value} size="small" />
//                     ))}
//                   </div>
//                 ),
//               }}
//             >
//               {supplierShifts.map((option) => (
//                 <MenuItem key={option} value={option}>
//                   {option}
//                 </MenuItem>
//               ))}
//             </TextField>
//           </Grid>
//           <Grid item xs={12} sm={4} md={2}>
//             <TextField
//               label="Start Date"
//               type="date"
//               value={startDate}
//               onChange={(e) => setStartDate(e.target.value)}
//               fullWidth
//               size="small"
//               InputLabelProps={{ shrink: true }}
//             />
//           </Grid>
//           <Grid item xs={12} sm={4} md={2}>
//             <TextField
//               label="End Date"
//               type="date"
//               value={endDate}
//               onChange={(e) => setEndDate(e.target.value)}
//               fullWidth
//               size="small"
//               InputLabelProps={{ shrink: true }}
//             />
//           </Grid>
//           <Grid item xs={12} sm={4} md={2}>
//             <TextField
//               select
//               label="Form Name"
//               value={formName}
//               onChange={handleFormNameChange}
//               fullWidth
//               size="small"
//               SelectProps={{
//                 multiple: true,
//                 renderValue: (selected) => (
//                   <div sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
//                     {selected.map((value) => (
//                       <Chip key={value} label={value} size="small" />
//                     ))}
//                   </div>
//                 ),
//               }}
//             >
//               <MenuItem
//                 value="all"
//                 sx={{ fontWeight: 'bold', bgcolor: '#f5f5f5', position: 'sticky', top: 0, zIndex: 1 }}
//               >
//                 <Checkbox
//                   checked={formName.length === formNames.length && formNames.length > 0}
//                   indeterminate={formName.length > 0 && formName.length < formNames.length}
//                 />
//                 <ListItemText
//                   primary={
//                     formName.length === formNames.length && formNames.length > 0
//                       ? 'Deselect All'
//                       : 'Select All'
//                   }
//                 />
//               </MenuItem>
//               {formNames.map((option) => (
//                 <MenuItem key={option} value={option}>
//                   <Checkbox checked={formName.indexOf(option) > -1} />
//                   <ListItemText primary={option} />
//                 </MenuItem>
//               ))}
//             </TextField>
//           </Grid>
//             <Grid item xs={12} sm={4} md={2}>
//               <TextField
//                 select
//                 label="Sub Form"
//                 value={subForm}
//                 onChange={handleSubFormChange}  // ← Updated handler
//                 fullWidth
//                 size="small"
//                 disabled={availableSubForms.length === 0}
//                 SelectProps={{
//                   multiple: true,
//                   renderValue: (selected) => (
//                     <div sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
//                       {selected.map((value) => (
//                         <Chip key={value} label={value} size="small" />
//                       ))}
//                     </div>
//                   ),
//                 }}
//               >
//                 <MenuItem value="all" sx={{ fontWeight: 'bold', bgcolor: '#f5f5f5', position: 'sticky', top: 0, zIndex: 1 }}>
//                   <Checkbox
//                     checked={subForm.length === availableSubForms.length && availableSubForms.length > 0}
//                     indeterminate={subForm.length > 0 && subForm.length < availableSubForms.length}
//                   />
//                   <ListItemText primary={subForm.length === availableSubForms.length ? 'Deselect All' : 'Select All'} />
//                 </MenuItem>

//                 {availableSubForms.map((option) => (
//                   <MenuItem key={option} value={option}>
//                     <Checkbox checked={subForm.includes(option)} />
//                     <ListItemText primary={option} />
//                   </MenuItem>
//                 ))}
//               </TextField>
//             </Grid>
//         </Grid>
//       </Collapse>

//       {formName.some((form) =>
//         ["Pre-Lamination", "Post-Lamination", "Bill of material verification"].includes(form)
//       ) && subForm.length === 0 && (
//         <Typography variant="h6" color="textSecondary" align="center" sx={{ mt: 2 }}>
//           Please select a subform to view the data.
//         </Typography>
//       )}

//       {loading && (
//         <div style={{ textAlign: "center", margin: "20px 0" }}>
//           <CircularProgress />
//         </div>
//       )}
//       {error && (
//         <Typography color="error" align="center" style={{ margin: "20px 0" }}>
//           {error}
//         </Typography>
//       )}
//       {formName.map((form) => {
//         if (form === "Pre-Lamination" || form === "Post-Lamination") {
//           return (
//             <PrePostLaminationTable
//               key={form}
//               formName={form}
//               data={tableData[form] || []}
//               subForm={subForm}
//               subFormMappings={
//                 form === "Pre-Lamination"
//                   ? preLaminationSubFormMappings
//                   : postLaminationSubFormMappings
//               }
//               startDate={startDate}
//               endDate={endDate}
//               shifts={shift}
//             />
//           );
//         } else if (form === "Bill of material verification") {
//           return (
//             <BOMTable
//               key={form}
//               data={tableData[form] || []}
//               startDate={startDate}
//               endDate={endDate}
//               shifts={shift}
//               subForm={subForm}
//             />
//           );
//         } else if (form === "Daily volume of the qualified modules") {
//           return (
//             <DailyVolumeTable
//               key={form}
//               data={tableData[form] || []}
//               startDate={startDate}
//               endDate={endDate}
//               shifts={shift}
//               subForm={subForm}
//             />
//           );
//         } else if (form === "Stringer") {
//           return (
//             <StringerTable
//               key={form}
//               data={tableData[form] || []}
//               startDate={startDate}
//               endDate={endDate}
//               shifts={shift}
//               subForm={subForm}
//             />
//           );
//         } else if (form === "Cell To Ribbon Peel Strength") {
//           return (
//             <CellToRibbonPeelStrengthTable
//               key={form}
//               data={tableData[form] || []}
//               startDate={startDate}
//               endDate={endDate}
//               shifts={shift}
//               subForm={subForm}
//             />
//           );
//         } else if (form === "Peel Strength Of Ribbon To String Connector") {
//           return (
//             <PeelStrengthTable
//               key={form}
//               data={tableData[form] || []}
//               startDate={startDate}
//               endDate={endDate}
//               shifts={shift}
//               subForm={subForm}
//             />
//           );
//         } else if (form === "Lamination machine parameters verification") {
//           return (
//             <LaminationMachineTable
//               key={form}
//               data={tableData[form] || []}
//               startDate={startDate}
//               endDate={endDate}
//               shifts={shift}
//               subForm={subForm}
//             />
//           );
//         } else if (form === "Calibration data verification of secondary module") {
//           return (
//             <CalibrationVerificationTable
//               key={form}
//               data={tableData[form] || []}
//               startDate={startDate}
//               endDate={endDate}
//               shifts={shift}
//               subForm={subForm}
//             />
//           );
//         } else if (form === "Flash test witness record after calibration") {
//           return (
//             <FlashTestWitnessTable
//               key={form}
//               data={tableData[form] || []}
//               startDate={startDate}
//               endDate={endDate}
//               shifts={shift}
//               subForm={subForm}
//             />
//           );
//         } else if (form === "Primary (Golden) Module Calibration record") {
//           return (
//             <PrimaryModuleCalibrationTable
//               key={form}
//               data={tableData[form] || []}
//               startDate={startDate}
//               endDate={endDate}
//               shifts={shift}
//               subForm={subForm}
//             />
//           );
//         } else if (form === "Frame sealant weight verification") {
//           return (
//             <FrameSealantWeightTable
//               key={form}
//               data={tableData[form] || []}
//               startDate={startDate}
//               endDate={endDate}
//               shifts={shift}
//               subForm={subForm}
//             />
//           );
//         } else if (form === "Junction Box sealant weight verification") {
//           return (
//             <JunctionBoxSealantWeightTable
//               key={form}
//               data={tableData[form] || []}
//               startDate={startDate}
//               endDate={endDate}
//               shifts={shift}
//               subForm={subForm}
//             />
//           );
//         } else if (form === "Junction Box Potting material ratio verification") {
//           return (
//             <JunctionBoxPottingMaterialTable
//               key={form}
//               data={tableData[form] || []}
//               startDate={startDate}
//               endDate={endDate}
//               shifts={shift}
//               subForm={subForm}
//             />
//           );
//         } else if (form === "Module dimensions check") {
//           return (
//             <ModuleDimensionCheckTable
//               key={form}
//               data={tableData[form] || []}
//               startDate={startDate}
//               endDate={endDate}
//               shifts={shift}
//               subForm={subForm}
//             />
//           );
//         } else if (form === "Record of rejected module during inspection") {
//           return (
//             <RecordRejectedModuleTable
//               key={form}
//               data={tableData[form] || []}
//               startDate={startDate}
//               endDate={endDate}
//               shifts={shift}
//               subForm={subForm}
//             />
//           );
//         } else if (form === "RFID Readability and Data Verification") {
//           return (
//             <RFIDReadabilityTable
//               key={form}
//               data={tableData[form] || []}
//               startDate={startDate}
//               endDate={endDate}
//               shifts={shift}
//               subForm={subForm}
//             />
//           );
//         } else if (form === "Machine Breakdown History") {
//           return (
//             <MachineBreakdownHistoryTable
//               key={form}
//               data={tableData[form] || []}
//               startDate={startDate}
//               endDate={endDate}
//               shifts={shift}
//               subForm={subForm}
//             />
//           );
//         } else if (form === "Root Cause Analysis") {
//           return (
//             <RootCauseAnalysisTable
//               key={form}
//               data={tableData[form] || []}
//               startDate={startDate}
//               endDate={endDate}
//               shifts={shift}
//               subForm={subForm}
//             />
//           );
//         }
//         return null;
//       })}
//     </div>
//   );
// };

// export default InspectionSummary;

import React, { useState, useEffect, useMemo, useRef, memo } from "react";
import {
  Box,
  Typography,
  Button,
  CircularProgress,
  Tabs,
  Tab,
  Alert,
  Paper,
  Fade,
  Chip
} from "@mui/material";
import {
  FilterList as FilterListIcon,
  FilterListOff as FilterListOffIcon,
  RestartAlt as ResetIcon,
  AssessmentOutlined as ReportIcon,
  TableChartOutlined as TableIcon,
  KeyboardArrowDown,
  Close,
  Search
} from "@mui/icons-material";
import apiClient from "../../../pages/keycloak/axiosInstance";

// Dynamic Table imports
import PrePostLaminationTable from "./FormTables/PrePostLaminationTable";
import BOMTable from "./FormTables/BOMTable";
import DailyVolumeTable from "./FormTables/DailyVolumeTable";
import StringerTable from "./FormTables/StringerTable";
import CellToRibbonPeelStrengthTable from "./FormTables/CellToRibbonPeelStrengthTable";
import PeelStrengthTable from "./FormTables/PeelStrengthTable";
import LaminationMachineTable from "./FormTables/LaminationMachineTable";
import CalibrationVerificationTable from "./FormTables/CalibrationVerificationTable";
import FlashTestWitnessTable from "./FormTables/FlashTestWitnessTable";
import PrimaryModuleCalibrationTable from "./FormTables/PrimaryModuleCalibrationTable";
import FrameSealantWeightTable from "./FormTables/FrameSealantWeightTable";
import JunctionBoxSealantWeightTable from "./FormTables/JunctionBoxSealantWeightTable";
import JunctionBoxPottingMaterialTable from "./FormTables/JunctionBoxPottingMaterialTable";
import ModuleDimensionCheckTable from "./FormTables/ModuleDimensionCheckTable";
import RecordRejectedModuleTable from "./FormTables/RecordRejectedModuleTable";
import RFIDReadabilityTable from "./FormTables/RFIDReadabilityTable";
import MachineBreakdownHistoryTable from "./FormTables/MachineBreakdownHistoryTable";
import RootCauseAnalysisTable from "./FormTables/RootCauseAnalysisTable";

const formMappings = {
  "Pre-Lamination": "PreLamination",
  "Post-Lamination": "PostLamination",
  "Bill of material verification": "BOM",
  "Daily volume of the qualified modules": "dailyVolumeQualifiedModules",
  "Stringer": "stringer",
  "Peel Strength Of Ribbon To String Connector": "PeelStrength",
  "Cell To Ribbon Peel Strength": "CellToRibbonPeelStrength",
  "Lamination machine parameters verification": "LaminationMachine",
  "Calibration data verification of secondary module": "calibrationVerificationOfSecondaryModule",
  "Flash test witness record after calibration": "FlashTestWitnessRecordAfterCalibration",
  "Primary (Golden) Module Calibration record": "PrimaryModuleCalibrationRecord",
  "Frame sealant weight verification": "FrameSealantWeightVerification",
  "Junction Box sealant weight verification": "JunctionBoxSealantWeightVerification",
  "Junction Box Potting material ratio verification": "JunctionBoxPottingMaterial",
  "Module dimensions check": "ModuleDimensionCheck",
  "Record of rejected module during inspection": "RecordRejectedModuleDuringInspection",
  "RFID Readability and Data Verification": "RFIDReadability",
  "Machine Breakdown History": "MachineBreakdownHistory",
  "Root Cause Analysis": "RootCauseAnalysis",
};

const preLaminationSubFormMappings = {
  "Shop Floor (Pre)": "shopFloor_pre",
  "Cell and Cutting Machine (Pre)": "CellAndCuttingMachine_pre",
  "Encapsulation Material (Front) (Pre)": "encapsulationMaterialFront_pre",
  "Encapsulation Material (Back) (Pre)": "encapsulationMaterialBack_pre",
  "Glass (Front & Back) (Pre)": "GlassFrontBack_pre",
  "Tabbing & Stringing (Pre)": "TabbingStringing_pre",
  "Auto Bussing (Pre)": "autoBussing_pre",
  "Barcode/RFID (Pre)": "barCodeRFID_pre",
  "Pre-Lamination EL & Re-work (Pre)": "PreLaminationELRework_pre",
};

const postLaminationSubFormMappings = {
  "Lamination (Post)": "Lamination_post",
  "Trimming/VI at 90 Degree (Post)": "Trimming_post",
  "Framing (Post)": "Framing_post",
  "JB Assembling & Soldering (Post)": "JbAssemblingSoldering_post",
  "Curing (Post)": "Curing_post",
  "Cleaning (Post)": "Cleaning_post",
  "Electrical Test (Post)": "electricalTest_post",
  "HiPot (Post)": "HiPot_post",
  "Post-Lamination EL (Post)": "PostLaminationEL_post",
  "Visual Inspections (Post)": "VisualInspections_post",
  "Packing (Post)": "Packing_post",
};

const bomSubFormMappings = {
  "Adhesive Sealant (BOM)": "AdhesiveSealant",
  "Cell (BOM)": "Cell",
  "Frame (BOM)": "Frame",
  "Cell Fixing Type (BOM)": "cellFixingType",
  "EVA Back (BOM)": "evaBack",
  "EVA Front (BOM)": "evaFront",
  "Flux (BOM)": "flux",
  "Glass Back (BOM)": "glassBack",
  "Glass Front (BOM)": "glassFront",
  "Interconnector (BOM)": "interconnector",
  "Junction Box (BOM)": "junctionBox",
  "Potting Material (BOM)": "pottingMaterial",
  "String Connector (BOM)": "stringConnector",
};

const SUBFORM_REQUIRED_FORMS = [
  "Pre-Lamination",
  "Post-Lamination",
  "Bill of material verification",
];

/* -------------------------------------------------------------
   CUSTOM REUSABLE MULTI-SELECT DROPDOWN
------------------------------------------------------------- */
const CustomMultiSelect = ({
  label,
  options = [],
  value = [],
  onChange,
  disabled = false,
  placeholder = "Select options..."
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef(null);

  // Close when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const filteredOptions = useMemo(() => {
    if (!searchTerm.trim()) return options;
    return options.filter((opt) =>
      opt.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [options, searchTerm]);

  const isAllSelected = options.length > 0 && value.length === options.length;

  const handleToggleOption = (option) => {
    if (value.includes(option)) {
      onChange(value.filter((item) => item !== option));
    } else {
      onChange([...value, option]);
    }
  };

  const handleToggleAll = () => {
    if (isAllSelected) {
      onChange([]);
    } else {
      onChange([...options]);
    }
  };

  return (
    <div style={{ position: "relative", width: "100%" }} ref={dropdownRef}>
      <label
        style={{
          display: "block",
          fontSize: "12px",
          fontWeight: 600,
          color: "#475569",
          marginBottom: "6px"
        }}
      >
        {label}
      </label>

      {/* Button Trigger */}
      <button
        type="button"
        disabled={disabled}
        onClick={() => setIsOpen((prev) => !prev)}
        style={{
          width: "100%",
          minHeight: "40px",
          padding: "6px 12px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          backgroundColor: disabled ? "#f8fafc" : "#ffffff",
          border: isOpen ? "1.5px solid #2563eb" : "1px solid #cbd5e1",
          borderRadius: "8px",
          cursor: disabled ? "not-allowed" : "pointer",
          outline: "none",
          transition: "all 0.15s ease",
          boxShadow: isOpen ? "0 0 0 3px rgba(37, 99, 235, 0.12)" : "none"
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "6px", flexWrap: "wrap", overflow: "hidden" }}>
          {value.length === 0 ? (
            <span style={{ color: "#94a3b8", fontSize: "13px" }}>{placeholder}</span>
          ) : value.length <= 1 ? (
            <span
              style={{
                backgroundColor: "#eff6ff",
                color: "#1d4ed8",
                fontSize: "12px",
                fontWeight: 600,
                padding: "2px 8px",
                borderRadius: "4px"
              }}
            >
              {value[0]}
            </span>
          ) : (
            <>
              <span
                style={{
                  backgroundColor: "#eff6ff",
                  color: "#1d4ed8",
                  fontSize: "12px",
                  fontWeight: 600,
                  padding: "2px 8px",
                  borderRadius: "4px"
                }}
              >
                {value[0]}
              </span>
              <span
                style={{
                  backgroundColor: "#f1f5f9",
                  color: "#475569",
                  fontSize: "12px",
                  fontWeight: 600,
                  padding: "2px 6px",
                  borderRadius: "4px"
                }}
              >
                +{value.length - 1} more
              </span>
            </>
          )}
        </div>
        <KeyboardArrowDown
          style={{
            fontSize: "18px",
            color: "#64748b",
            transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.2s ease"
          }}
        />
      </button>

      {/* Floating Menu */}
      {isOpen && (
        <div
          style={{
            position: "absolute",
            top: "calc(100% + 4px)",
            left: 0,
            width: "100%",
            minWidth: "240px",
            backgroundColor: "#ffffff",
            borderRadius: "8px",
            border: "1px solid #e2e8f0",
            boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.05)",
            zIndex: 100,
            overflow: "hidden"
          }}
        >
          {/* Quick Search */}
          {options.length > 5 && (
            <div style={{ padding: "8px", borderBottom: "1px solid #f1f5f9", position: "relative" }}>
              <Search style={{ position: "absolute", left: "16px", top: "16px", fontSize: "16px", color: "#94a3b8" }} />
              <input
                type="text"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{
                  width: "100%",
                  padding: "6px 10px 6px 30px",
                  fontSize: "12px",
                  border: "1px solid #e2e8f0",
                  borderRadius: "6px",
                  outline: "none",
                  boxSizing: "border-box"
                }}
              />
            </div>
          )}

          {/* Action Bar (Select All / Clear) */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "8px 12px",
              backgroundColor: "#f8fafc",
              borderBottom: "1px solid #e2e8f0"
            }}
          >
            <label
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                fontSize: "12px",
                fontWeight: 600,
                color: "#1e293b",
                cursor: "pointer"
              }}
            >
              <input
                type="checkbox"
                checked={isAllSelected}
                onChange={handleToggleAll}
                style={{ accentColor: "#2563eb", cursor: "pointer", width: "15px", height: "15px" }}
              />
              {isAllSelected ? "Deselect All" : "Select All"}
            </label>
            <span style={{ fontSize: "11px", color: "#64748b", fontWeight: 500 }}>
              {value.length}/{options.length}
            </span>
          </div>

          {/* Options List */}
          <div style={{ maxHeight: "200px", overflowY: "auto", padding: "4px 0" }}>
            {filteredOptions.length === 0 ? (
              <div style={{ padding: "12px", textAlign: "center", fontSize: "12px", color: "#94a3b8" }}>
                No options found
              </div>
            ) : (
              filteredOptions.map((option) => {
                const checked = value.includes(option);
                return (
                  <div
                    key={option}
                    onClick={() => handleToggleOption(option)}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      padding: "7px 12px",
                      fontSize: "13px",
                      color: checked ? "#1d4ed8" : "#334155",
                      backgroundColor: checked ? "#eff6ff" : "transparent",
                      cursor: "pointer",
                      transition: "background 0.1s ease"
                    }}
                    onMouseEnter={(e) => {
                      if (!checked) e.currentTarget.style.backgroundColor = "#f8fafc";
                    }}
                    onMouseLeave={(e) => {
                      if (!checked) e.currentTarget.style.backgroundColor = "transparent";
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={checked}
                      onChange={() => {}} // Handled by container click
                      style={{ accentColor: "#2563eb", cursor: "pointer", width: "14px", height: "14px" }}
                    />
                    <span style={{ flex: 1, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                      {option}
                    </span>
                  </div>
                );
              })
            )}
          </div>
        </div>
      )}
    </div>
  );
};

/* -------------------------------------------------------------
   CUSTOM SINGLE-SELECT & DATE COMPONENTS
------------------------------------------------------------- */
const CustomSingleSelect = ({ label, value, options = [], onChange, placeholder = "Select..." }) => (
  <div style={{ width: "100%" }}>
    <label style={{ display: "block", fontSize: "12px", fontWeight: 600, color: "#475569", marginBottom: "6px" }}>
      {label}
    </label>
    <div style={{ position: "relative" }}>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        style={{
          width: "100%",
          height: "40px",
          padding: "6px 28px 6px 12px",
          fontSize: "13px",
          color: value ? "#1e293b" : "#94a3b8",
          backgroundColor: "#ffffff",
          border: "1px solid #cbd5e1",
          borderRadius: "8px",
          outline: "none",
          appearance: "none",
          cursor: "pointer"
        }}
      >
        <option value="">{placeholder}</option>
        {options.map((opt) => (
          <option key={opt.value || opt} value={opt.value || opt} style={{ color: "#1e293b" }}>
            {opt.label || opt}
          </option>
        ))}
      </select>
      <KeyboardArrowDown
        style={{
          position: "absolute",
          right: "8px",
          top: "50%",
          transform: "translateY(-50%)",
          fontSize: "18px",
          color: "#64748b",
          pointerEvents: "none"
        }}
      />
    </div>
  </div>
);

const CustomDateInput = ({ label, value, onChange }) => (
  <div style={{ width: "100%" }}>
    <label style={{ display: "block", fontSize: "12px", fontWeight: 600, color: "#475569", marginBottom: "6px" }}>
      {label}
    </label>
    <input
      type="date"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      style={{
        width: "100%",
        height: "40px",
        padding: "6px 10px",
        fontSize: "13px",
        color: value ? "#1e293b" : "#94a3b8",
        backgroundColor: "#ffffff",
        border: "1px solid #cbd5e1",
        borderRadius: "8px",
        outline: "none",
        boxSizing: "border-box"
      }}
    />
  </div>
);

// Memoized table viewer
const TableViewer = memo(({ form, tableData, subForm, startDate, endDate, shift }) => {
  const data = tableData[form] || [];

  switch (form) {
    case "Pre-Lamination":
    case "Post-Lamination":
      return (
        <PrePostLaminationTable
          formName={form}
          data={data}
          subForm={subForm}
          subFormMappings={
            form === "Pre-Lamination" ? preLaminationSubFormMappings : postLaminationSubFormMappings
          }
          startDate={startDate}
          endDate={endDate}
          shifts={shift}
        />
      );
    case "Bill of material verification":
      return <BOMTable data={data} startDate={startDate} endDate={endDate} shifts={shift} subForm={subForm} />;
    case "Daily volume of the qualified modules":
      return <DailyVolumeTable data={data} startDate={startDate} endDate={endDate} shifts={shift} subForm={subForm} />;
    case "Stringer":
      return <StringerTable data={data} startDate={startDate} endDate={endDate} shifts={shift} subForm={subForm} />;
    case "Cell To Ribbon Peel Strength":
      return <CellToRibbonPeelStrengthTable data={data} startDate={startDate} endDate={endDate} shifts={shift} subForm={subForm} />;
    case "Peel Strength Of Ribbon To String Connector":
      return <PeelStrengthTable data={data} startDate={startDate} endDate={endDate} shifts={shift} subForm={subForm} />;
    case "Lamination machine parameters verification":
      return <LaminationMachineTable data={data} startDate={startDate} endDate={endDate} shifts={shift} subForm={subForm} />;
    case "Calibration data verification of secondary module":
      return <CalibrationVerificationTable data={data} startDate={startDate} endDate={endDate} shifts={shift} subForm={subForm} />;
    case "Flash test witness record after calibration":
      return <FlashTestWitnessTable data={data} startDate={startDate} endDate={endDate} shifts={shift} subForm={subForm} />;
    case "Primary (Golden) Module Calibration record":
      return <PrimaryModuleCalibrationTable data={data} startDate={startDate} endDate={endDate} shifts={shift} subForm={subForm} />;
    case "Frame sealant weight verification":
      return <FrameSealantWeightTable data={data} startDate={startDate} endDate={endDate} shifts={shift} subForm={subForm} />;
    case "Junction Box sealant weight verification":
      return <JunctionBoxSealantWeightTable data={data} startDate={startDate} endDate={endDate} shifts={shift} subForm={subForm} />;
    case "Junction Box Potting material ratio verification":
      return <JunctionBoxPottingMaterialTable data={data} startDate={startDate} endDate={endDate} shifts={shift} subForm={subForm} />;
    case "Module dimensions check":
      return <ModuleDimensionCheckTable data={data} startDate={startDate} endDate={endDate} shifts={shift} subForm={subForm} />;
    case "Record of rejected module during inspection":
      return <RecordRejectedModuleTable data={data} startDate={startDate} endDate={endDate} shifts={shift} subForm={subForm} />;
    case "RFID Readability and Data Verification":
      return <RFIDReadabilityTable data={data} startDate={startDate} endDate={endDate} shifts={shift} subForm={subForm} />;
    case "Machine Breakdown History":
      return <MachineBreakdownHistoryTable data={data} startDate={startDate} endDate={endDate} shifts={shift} subForm={subForm} />;
    case "Root Cause Analysis":
      return <RootCauseAnalysisTable data={data} startDate={startDate} endDate={endDate} shifts={shift} subForm={subForm} />;
    default:
      return null;
  }
});

/* -------------------------------------------------------------
   MAIN COMPONENT
------------------------------------------------------------- */
const InspectionSummary = () => {
  const [supplier, setSupplier] = useState("");
  const [shift, setShift] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [formName, setFormName] = useState([]);
  const [subForm, setSubForm] = useState([]);
  const [tableData, setTableData] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [suppliers, setSuppliers] = useState([]);
  const [supplierShifts, setSupplierShifts] = useState([]);
  const [showFilters, setShowFilters] = useState(true);
  const [selectedTab, setSelectedTab] = useState(0);

  const formNames = useMemo(() => Object.keys(formMappings), []);
  const projectId = localStorage.getItem("selectedProject");

  const allowedSuppliers = useMemo(() => {
    if (!projectId) return [];
    const userRoles = JSON.parse(sessionStorage.getItem("userRoles") || "[]");
    return suppliers.filter((sup) => userRoles.includes(`${projectId}_${sup.name}_view`));
  }, [suppliers, projectId]);

  const availableSubForms = useMemo(() => {
    const subforms = [];
    if (formName.includes("Pre-Lamination")) subforms.push(...Object.keys(preLaminationSubFormMappings));
    if (formName.includes("Post-Lamination")) subforms.push(...Object.keys(postLaminationSubFormMappings));
    if (formName.includes("Bill of material verification")) subforms.push(...Object.keys(bomSubFormMappings));
    return [...new Set(subforms)];
  }, [formName]);

  useEffect(() => {
    setSubForm((prev) => prev.filter((s) => availableSubForms.includes(s)));
  }, [availableSubForms]);

  useEffect(() => {
    if (selectedTab >= formName.length) {
      setSelectedTab(0);
    }
  }, [formName, selectedTab]);

  useEffect(() => {
    const fetchSuppliers = async () => {
      try {
        if (!projectId) {
          setError("No active Project ID found.");
          return;
        }
        const response = await apiClient.post(`get_supplier_names`, { projectId });
        if (Array.isArray(response.data)) {
          const supplierData = response.data
            .filter((info) => Boolean(info?.name))
            .map((info) => ({ name: info.name, shift: info.shift }));
          setSuppliers(supplierData);
        } else {
          setError("Invalid supplier response format.");
        }
      } catch (err) {
        setError("Error fetching suppliers.");
      }
    };
    fetchSuppliers();
  }, [projectId]);

  const handleSupplierChange = (selectedName) => {
    setSupplier(selectedName);
    setShift([]);
    const item = suppliers.find((s) => s.name === selectedName);
    setSupplierShifts(
      item?.shift === "MorningAfternoonNight"
        ? ["Morning", "Afternoon", "Night"]
        : item ? ["Day", "Night"] : []
    );
  };

  const handleClearFilters = () => {
    setSupplier("");
    setShift([]);
    setStartDate("");
    setEndDate("");
    setFormName([]);
    setSubForm([]);
    setTableData({});
    setError(null);
  };

  // Debounced API fetch
  useEffect(() => {
    const timer = setTimeout(() => {
      const fetchData = async () => {
        const requiresSub = formName.some((f) => SUBFORM_REQUIRED_FORMS.includes(f));
        if (
          !projectId ||
          !supplier ||
          shift.length === 0 ||
          !startDate ||
          !endDate ||
          formName.length === 0 ||
          (requiresSub && subForm.length === 0)
        ) {
          setTableData({});
          return;
        }

        setLoading(true);
        setError(null);

        try {
          const apiFormNames = formName.map((name) => formMappings[name]);
          const apiSubForms = subForm
            .map(
              (name) =>
                preLaminationSubFormMappings[name] ||
                postLaminationSubFormMappings[name] ||
                bomSubFormMappings[name]
            )
            .filter(Boolean);

          const response = await apiClient.get(`inspection_summary`, {
            params: {
              projectId,
              inspectionSupplier: supplier,
              inspectionShift: shift.join(","),
              date: startDate,
              endDate,
              formName: apiFormNames.join(","),
              subForm: apiSubForms.join(","),
            },
          });

          if (response.data?.status === "success") {
            const raw = Array.isArray(response.data.data) ? response.data.data : [];
            const subSet = new Set(apiSubForms);
            const isSubFilter = apiSubForms.length > 0;
            const grouped = Object.fromEntries(formName.map((f) => [f, []]));

            raw.forEach((item) => {
              const base = {
                inspectionDate: item.inspectionDate ?? "N/A",
                inspectionShift: item.inspectionShift ?? "N/A",
                inspectionSupplier: item.inspectionSupplier ?? "N/A",
                inspectorName: item.inspectorName ?? "N/A",
                projectId: item.projectId ?? projectId,
                status: item.status ?? "N/A",
                zip_url: item.zip_url || "N/A",
                form_data: item.form_data || {},
              };

              formName.forEach((uiName) => {
                const apiKey = formMappings[uiName];
                if (item[apiKey]) {
                  Object.entries(item[apiKey]).forEach(([subKey, details]) => {
                    if (isSubFilter && !subSet.has(subKey)) return;

                    if (subKey === "TabbingStringing_pre" && details?.TabbingStringing) {
                      Object.entries(details.TabbingStringing).forEach(([table, obsList]) => {
                        if (Array.isArray(obsList)) {
                          obsList.forEach((obs) => {
                            grouped[uiName].push({
                              ...base,
                              subForm: subKey,
                              tableName: table,
                              field: obs.product ?? obs.field ?? "N/A",
                              frequency: obs.frequency ?? "N/A",
                              specification: obs.specifications ?? obs.specification ?? "N/A",
                              obs1: obs.observation1 ?? obs.obs1 ?? "N/A",
                              obs2: obs.observation2 ?? obs.obs2 ?? "N/A",
                              remarks: details.nonConformance ?? "N/A",
                            });
                          });
                        }
                      });
                    } else if (subKey === "VisualInspections_post" && details) {
                      Object.entries(details).forEach(([table, obsList]) => {
                        if (table === "nonConformance") return;
                        if (table === "ModuleInspection" && Array.isArray(obsList)) {
                          obsList.forEach((mod) => {
                            grouped[uiName].push({
                              ...base,
                              subForm: subKey,
                              tableName: table,
                              moduleInspection: mod.moduleNumber ?? "N/A",
                              moduleStatus: mod.status ?? "N/A",
                              remarks: mod.remarks ?? "",
                            });
                          });
                        } else if (Array.isArray(obsList)) {
                          obsList.forEach((obs) => {
                            grouped[uiName].push({
                              ...base,
                              subForm: subKey,
                              tableName: table,
                              field: obs.product ?? obs.field ?? "N/A",
                              frequency: obs.frequency ?? "N/A",
                              specification: obs.specifications ?? obs.specification ?? "N/A",
                              obs1: obs.observation1 ?? obs.obs1 ?? "N/A",
                              obs2: obs.observation2 ?? obs.obs2 ?? "N/A",
                              remarks: details.nonConformance ?? "N/A",
                            });
                          });
                        }
                      });
                    } else if (details && typeof details === "object") {
                      Object.entries(details).forEach(([table, val]) => {
                        if (table === "nonConformance" || table === "ModuleInspection") return;
                        if (Array.isArray(val)) {
                          val.forEach((obs) => {
                            grouped[uiName].push({
                              ...base,
                              subForm: subKey,
                              tableName: table,
                              field: obs.field ?? obs.product ?? "N/A",
                              frequency: obs.frequency ?? "N/A",
                              specification: obs.specifications ?? obs.specification ?? "N/A",
                              obs1: obs.observation1 ?? obs.obs1 ?? "N/A",
                              obs2: obs.observation2 ?? obs.obs2 ?? "N/A",
                              remarks: details.nonConformance ?? "N/A",
                              moduleInspection: obs.moduleNumber ?? "N/A",
                            });
                          });
                        }
                      });
                    }
                  });
                } else if (item.form_name === apiKey) {
                  if (!isSubFilter || !item.sub_form || subSet.has(item.sub_form)) {
                    grouped[uiName].push(base);
                  }
                }
              });
            });

            setTableData(grouped);
          } else {
            setError(response.data?.message || "Failed to load inspection summary.");
            setTableData({});
          }
        } catch (err) {
          setError("Failed to fetch inspection summary data.");
          setTableData({});
        } finally {
          setLoading(false);
        }
      };

      fetchData();
    }, 400);

    return () => clearTimeout(timer);
  }, [supplier, shift, startDate, endDate, formName, subForm, projectId]);

  const requiresSubWarning = formName.some((f) => SUBFORM_REQUIRED_FORMS.includes(f)) && subForm.length === 0;

  return (
    <Box sx={{ p: { xs: 2 }, minHeight: "100%" }}>
      {/* Top Bar */}
      <Paper
        elevation={0}
        sx={{
          px: 2,
          py: 1,
          mb: 2.5,
          borderRadius: 2,
          border: "1px solid #e2e8f0",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 2
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <Box sx={{ p: 1, borderRadius: 1.5, bgcolor: "#eff6ff", color: "#2563eb", display: "flex" }}>
            <ReportIcon />
          </Box>
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 700, color: "#0f172a" }}>
              Inspection Summary
            </Typography>
            <Typography variant="caption" sx={{ color: "#64748b" }}>
              Custom fast-filter dashboard
            </Typography>
          </Box>
        </Box>

        <Box sx={{ display: "flex", gap: 1.5 }}>
          <Button
            size="small"
            variant="outlined"
            onClick={handleClearFilters}
            startIcon={<ResetIcon />}
            sx={{ textTransform: "none", color: "#475569", borderColor: "#cbd5e1" }}
          >
            Reset
          </Button>
          <Button
            size="small"
            variant={showFilters ? "contained" : "outlined"}
            onClick={() => setShowFilters((p) => !p)}
            startIcon={showFilters ? <FilterListOffIcon /> : <FilterListIcon />}
            sx={{ textTransform: "none", bgcolor: showFilters ? "#2563eb" : "transparent" }}
          >
            {showFilters ? "Hide Filters" : "Show Filters"}
          </Button>
        </Box>
      </Paper>

      {/* Modern Custom Filters Card */}
      {showFilters && (
        <Paper
          elevation={0}
          sx={{
            p: 2.5,
            mb: 3,
            borderRadius: 2,
            border: "1px solid #e2e8f0",
            bgcolor: "#ffffff"
          }}
        >
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                sm: "repeat(2, 1fr)",
                md: "repeat(3, 1fr)",
                lg: "repeat(6, 1fr)"
              },
              gap: 2
            }}
          >
            {/* 1. Supplier */}
            <CustomSingleSelect
              label="Supplier"
              value={supplier}
              options={allowedSuppliers.map((s) => ({ value: s.name, label: s.name }))}
              onChange={handleSupplierChange}
              placeholder="Select supplier"
            />

            {/* 2. Shift (Multi) */}
            <CustomMultiSelect
              label="Shift"
              options={supplierShifts}
              value={shift}
              onChange={setShift}
              disabled={!supplier}
              placeholder="Select shifts"
            />

            {/* 3. Start Date */}
            <CustomDateInput label="Start Date" value={startDate} onChange={setStartDate} />

            {/* 4. End Date */}
            <CustomDateInput label="End Date" value={endDate} onChange={setEndDate} />

            {/* 5. Form Name (Multi with Select All) */}
            <CustomMultiSelect
              label="Form Category"
              options={formNames}
              value={formName}
              onChange={setFormName}
              placeholder="Select forms"
            />

            {/* 6. Sub Form (Multi with Select All) */}
            <CustomMultiSelect
              label="Sub Form"
              options={availableSubForms}
              value={subForm}
              onChange={setSubForm}
              disabled={availableSubForms.length === 0}
              placeholder={availableSubForms.length === 0 ? "Select form first" : "Select subforms"}
            />
          </Box>
        </Paper>
      )}

      {/* Warnings & Errors */}
      {requiresSubWarning && (
        <Alert severity="warning" sx={{ mb: 2.5, borderRadius: 2 }}>
          Please select at least one <strong>Sub Form</strong> to load data for Pre-Lamination, Post-Lamination, or BOM.
        </Alert>
      )}

      {error && (
        <Alert severity="error" sx={{ mb: 2.5, borderRadius: 2 }}>
          {error}
        </Alert>
      )}

      {/* Results View */}
      {loading ? (
        <Box sx={{ py: 10, textAlign: "center" }}>
          <CircularProgress size={36} />
          <Typography variant="body2" sx={{ color: "#64748b", mt: 1.5 }}>
            Loading inspection records...
          </Typography>
        </Box>
      ) : formName.length > 0 ? (
        <Paper elevation={0} sx={{ borderRadius: 2, border: "1px solid #e2e8f0", overflow: "hidden" }}>
          <Box sx={{ borderBottom: "1px solid #e2e8f0", bgcolor: "#fcfdfd" }}>
            <Tabs
              value={selectedTab}
              onChange={(_, val) => setSelectedTab(val)}
              variant="scrollable"
              scrollButtons="auto"
              sx={{
                px: 2,
                minHeight: 48,
                "& .MuiTab-root": { textTransform: "none", fontWeight: 600, fontSize: "13px" }
              }}
            >
              {formName.map((name) => {
                const count = (tableData[name] || []).length;
                return (
                  <Tab
                    key={name}
                    label={
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <span>{name}</span>
                        <Chip
                          label={count}
                          size="small"
                          sx={{
                            height: 20,
                            fontSize: "11px",
                            fontWeight: 700,
                            bgcolor: count > 0 ? "#eff6ff" : "#f1f5f9",
                            color: count > 0 ? "#2563eb" : "#94a3b8"
                          }}
                        />
                      </Box>
                    }
                  />
                );
              })}
            </Tabs>
          </Box>

          <Box sx={{ p: 2 }}>
            <Fade in={true} key={formName[selectedTab]}>
              <Box>
                <TableViewer
                  form={formName[selectedTab]}
                  tableData={tableData}
                  subForm={subForm}
                  startDate={startDate}
                  endDate={endDate}
                  shift={shift}
                />
              </Box>
            </Fade>
          </Box>
        </Paper>
      ) : (
        <Paper
          elevation={0}
          sx={{
            py: 8,
            px: 3,
            textAlign: "center",
            borderRadius: 2,
            border: "1px dashed #cbd5e1",
            bgcolor: "#ffffff"
          }}
        >
          <TableIcon sx={{ fontSize: 36, color: "#94a3b8", mb: 1 }} />
          <Typography variant="subtitle1" sx={{ fontWeight: 600, color: "#334155" }}>
            No Forms Selected
          </Typography>
          <Typography variant="body2" sx={{ color: "#64748b" }}>
            Select a supplier and forms from the filter bar above.
          </Typography>
        </Paper>
      )}
    </Box>
  );
};

export default InspectionSummary;